var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
import { html, LitElement } from 'lit';
import { SdsButtonBase } from '../_sds-button-base.lit';
import styles from './sds-button.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * Control that represents button.
 */
let SdsButton = (() => {
    let _classDecorators = [sdsCustomElement('sds-button')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsButtonBase;
    var SdsButton = _classThis = class extends _classSuper {
        render() {
            if (this.type == 'link' && !this.icon && this.href && !this.target) {
                return html ` ${this.renderButtonLink()} `;
            }
            else if (this.type == 'link' &&
                !this.disabled &&
                !this.icon &&
                this.href &&
                this.target) {
                return html ` ${this.renderButtonLinkWithTarget()} `;
            }
            else if (this.type == 'link' && !this.disabled && this.icon && this.href) {
                /* We have not this case(button icon link or button with text icon link), I added this part, that worked in Sandbox*/
                return html ` ${this.renderButtonLinkIcon()} `;
            }
            else if (this.icon && this.label) {
                return html ` ${this.renderButtonTextIcon()} `;
            }
            else if (this.icon && !this.label) {
                return html ` ${this.renderButtonIcon()} `;
            }
            else {
                return html ` ${this.renderButton()} `;
            }
        }
        renderButtonLink() {
            return html `<a
            class="${this.getClasses()}"
            href="${this.href}"
            aria-label="${this.label}"
            aria-disabled="${this.disabled ? 'true' : 'false'}"
        >
            ${this.label}
        </a> `;
        }
        renderButtonLinkWithTarget() {
            const isExternal = this.target === '_blank';
            const accessibleLabel = isExternal ? `${this.label} (opens in a new tab)` : this.label;
            return html `
            <a
                class="${this.getClasses()}"
                href="${this.href}"
                target="${this.target}"
                aria-label="${accessibleLabel}"
                aria-disabled="${this.disabled ? 'true' : 'false'}"
                rel="${isExternal ? 'noopener noreferrer' : ''}"
            >
                ${this.label}
            </a>
        `;
        }
        /* We have not this case(button icon link or button with text icon link), I added this part, that worked in Sandbox*/
        renderButtonLinkIcon() {
            return html `
            <a class="${this.getClasses()}" href="${this.href}">
                ${this.renderIcon()} ${this.label}
            </a>
        `;
        }
        renderButton() {
            return html `
            <button
                part="sds-button"
                class="${this.getClasses()}"
                .disabled="${this.disabled}"
                aria-disabled="${this.disabled ? 'true' : 'false'}"
                aria-busy="${this.loading ? 'true' : 'false'}"
                aria-label="${this.loading ? 'Loading... Please wait' : this.label}"
                type="${this.buttonType}"
            >
                ${this.renderLoading()} ${this.label}
            </button>
        `;
        }
        renderButtonTextIcon() {
            return html `
            <button
                part="sds-button"
                class="${this.getClasses()}"
                .disabled="${this.disabled}"
                aria-disabled="${this.disabled ? 'true' : 'false'}"
                aria-busy="${this.loading ? 'true' : 'false'}"
                aria-label="${this.loading ? 'Loading... Please wait' : this.label}"
            >
                ${this.renderLoading()} ${this.renderIcon()} ${this.label}
            </button>
        `;
        }
        renderButtonIcon() {
            return html `
            <button
                part="sds-button"
                class="${this.getClasses()}"
                .disabled="${this.disabled}"
                aria-disabled="${this.disabled ? 'true' : 'false'}"
                aria-busy="${this.loading ? 'true' : 'false'}"
                aria-label="${this.loading ? 'Loading... Please wait' : this.iconName}"
            >
                ${this.renderLoading()} ${this.renderIcon()} ${this.renderHint()}
                ${this.renderBadge()}
            </button>
        `;
        }
        renderIcon() {
            return html `
            <sds-icon size="${this._iconSize}" name="${this.icon}" aria-hidden="true"></sds-icon>
        `;
        }
        renderLoading() {
            if (this.loading) {
                const loaderColor = ['filled', 'elevated', 'primary'].includes(this.type)
                    ? 'white'
                    : this.type === 'transparent'
                        ? 'transparent'
                        : 'accent';
                return html ` <sds-loader color="${loaderColor}"></sds-loader> `;
            }
        }
        renderHint() {
            if (this.hint && (this.type === 'ghost' || this.type === 'tertiary')) {
                return html ` <div class="sds-button__hint" aria-hidden="true"></div> `;
            }
        }
        renderBadge() {
            if (this.badge) {
                return html `
                <div
                    class="sds-button__badge"
                    aria-hidden="${this.badge ? 'false' : 'true'}"
                    aria-label="${this.badge}"
                >
                    ${this.badge}
                </div>
            `;
            }
        }
    };
    __setFunctionName(_classThis, "SdsButton");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsButton = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.shadowRootOptions = Object.assign(Object.assign({}, LitElement.shadowRootOptions), { delegatesFocus: true });
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsButton = _classThis;
})();
export { SdsButton };
